import React from "react";

type TProps = {
    color?: string
}

export function InfoSvg({color}: TProps) {
    return (
        <svg
            // width="4.3rem"
            // height="4.3rem"
            viewBox="0 0 43 43"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M43.292 23.662c-10.841 0-19.63 8.789-19.63 19.63 0 10.842 8.789 19.63 19.63 19.63 10.842 0 19.63-8.788 19.63-19.63 0-10.841-8.788-19.63-19.63-19.63m-21.5 19.63c0-11.875 9.625-21.5 21.5-21.5 11.876 0 21.5 9.625 21.5 21.5 0 11.876-9.624 21.5-21.5 21.5-11.875 0-21.5-9.624-21.5-21.5m21.5-10.282c.516 0 .935.419.935.935v1.87a.935.935 0 01-1.87 0v-1.87c0-.516.42-.935.935-.935m0 7.478c.516 0 .935.419.935.935V52.64a.935.935 0 01-1.87 0V41.423c0-.516.42-.935.935-.935"
                transform="translate(-1101.508 -456) translate(1079.716 434.208)"
                fill={color ? color : "#FFF"}
                stroke="none"
                strokeWidth={1}
                fillRule="evenodd"
            />
        </svg>
    )
}

export function PixelNotConnectedSvg({color}: TProps) {
    return (
        <svg viewBox="0 0 21.5005 21.5005"
             xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M27.94 11.88a.75.75 0 010 1.06l-2.97 2.97 3.94 3.94 2.969-2.97a.75.75 0 111.06 1.06l-2.97 2.97.057.055a2.75 2.75 0 010 3.89L27.94 26.94a7.114 7.114 0 01-9.502.502L12.94 32.94a.75.75 0 11-1.061-1.06l5.498-5.499a7.114 7.114 0 01.502-9.502l2.086-2.086a2.75 2.75 0 013.889 0l.056.056 2.969-2.97a.75.75 0 011.06 0zm-5.146 3.974a1.25 1.25 0 00-1.768 0L18.94 17.94a5.614 5.614 0 007.939 7.94l2.086-2.087a1.25 1.25 0 000-1.768l-6.171-6.17z"
                transform="translate(-144.536 -489.16) translate(132.877 477.5)"
                fill={color ? color : "#FFF"}
                stroke="none"
                strokeWidth={1}
                fillRule="evenodd"
            />
        </svg>
    )
}

export function SuccessSvg({color}: TProps) {
    return (
        <svg viewBox="0 0 49.0747973 49.0747973"
             xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1216.008 506.702c-12.373 0-22.403 10.03-22.403 22.404 0 12.373 10.03 22.403 22.403 22.403 12.374 0 22.404-10.03 22.404-22.403a22.69 22.69 0 00-.37-4.076 1.067 1.067 0 012.1-.384c.265 1.447.404 2.936.404 4.46 0 13.553-10.984 24.537-24.538 24.537-13.553 0-24.537-10.984-24.537-24.537 0-13.554 10.984-24.538 24.537-24.538 4.936 0 9.536 1.46 13.385 3.969a1.068 1.068 0 01-1.165 1.788 22.295 22.295 0 00-12.22-3.623m19.959 8.846a1.07 1.07 0 010 1.51l-19.203 19.204a1.07 1.07 0 01-1.511 0l-8.535-8.535a1.07 1.07 0 010-1.51 1.07 1.07 0 011.51 0l7.78 7.781 18.448-18.45a1.07 1.07 0 011.51 0"
                transform="translate(-1191.471 -504.568)"
                fill={color ? color : "#FFF"}
                stroke="none"
                strokeWidth={1}
                fillRule="evenodd"
            />
        </svg>
    )
}

export function PixelConnectedSvg({color}: TProps) {
    return (
        <svg viewBox="0 0 16.5768483 11.3744571"
             xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M30.836 18.813l-10.597 9.874a.75.75 0 01-1.061 0l-4.48-4.576a.75.75 0 111.062-1.06l3.949 4.045 10.066-9.344a.75.75 0 111.06 1.061z"
                transform="translate(-147.356 -495.033) translate(132.877 477.5)"
                fill={color ? color : "#FFF"}
                stroke="none"
                strokeWidth={1}
                fillRule="evenodd"
            />
        </svg>
    )
}


export function FailedSvg({color}: TProps) {
    return (
        <svg viewBox="0 0 45.9218259 40.0005232"
             xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1219.7 505.873c-1.22-2.033-4.163-2.033-5.383 0l-17.722 29.535c-1.256 2.093.251 4.755 2.691 4.755h35.444c2.44 0 3.945-2.662 2.692-4.755l-17.722-29.535zm-7.179-1.076c2.032-3.388 6.942-3.388 8.972 0l17.722 29.536c2.093 3.486-.418 7.923-4.485 7.923h-35.444c-4.066 0-6.577-4.437-4.485-7.923l17.72-29.536zm4.487 10.253c.578 0 1.047.466 1.047 1.046v8.371a1.047 1.047 0 01-2.093 0v-8.371c0-.58.469-1.046 1.046-1.046zm0 14.65c.578 0 1.047.466 1.047 1.046v2.093a1.047 1.047 0 01-2.093 0v-2.093c0-.58.469-1.047 1.046-1.047z"
                transform="translate(-1194.047 -502.256)"
                fill={color ? color : "#FFF"}
                stroke="none"
                strokeWidth={1}
                fillRule="evenodd"
            />
        </svg>
    )
}

export function ProcessSvg({color}: TProps) {
    return (
        <svg viewBox="0 0 23.4996037 19.5"
             xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M22.41 14.16c-2.379 0-4.519 1.055-5.996 2.743a.75.75 0 11-1.129-.988c1.746-1.994 4.29-3.256 7.124-3.256 5.29 0 9.55 4.381 9.55 9.75v.41l.914-.934a.75.75 0 111.072 1.048l-2.2 2.25a.746.746 0 01-1.072 0l-2.2-2.25a.75.75 0 111.072-1.048l.914.934v-.41c0-4.572-3.62-8.25-8.05-8.25m-8.8 5.25c.202 0 .395.081.536.226l2.2 2.25a.75.75 0 11-1.072 1.048L14.36 22v.41c0 4.572 3.62 8.25 8.05 8.25 2.378 0 4.518-1.056 5.995-2.744a.75.75 0 111.13.988c-1.747 1.994-4.29 3.256-7.125 3.256-5.29 0-9.55-4.38-9.55-9.75V22l-.914.934a.75.75 0 11-1.072-1.048l2.2-2.25a.746.746 0 01.536-.226"
                transform="translate(-143.537 -490.16) translate(132.877 477.5)"
                fill={color ? color : "#FFF"}
                stroke="none"
                strokeWidth={1}
                fillRule="evenodd"
            />
        </svg>
    )
}

export function FileUpload({color}: TProps) {
    return (
        <svg viewBox="0 0 46.8625 32.6"
             xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient">
                    <stop stopColor="#FFFFFF" offset="0%"/>
                    <stop stopColor="#FFFFFF" offset="100%"/>
                </linearGradient>
            </defs>
            <path
                d="M1180.99 588.933c-7.637 0-13.874 6.003-14.245 13.545a1.019 1.019 0 01-.766.938 7.136 7.136 0 00-5.364 6.91 7.13 7.13 0 007.13 7.132h4.076a1.02 1.02 0 010 2.038h-4.075a9.17 9.17 0 01-2.985-17.84c.776-8.281 7.746-14.76 16.229-14.76 6.1 0 11.418 3.353 14.211 8.31 5.807.95 10.239 5.989 10.239 12.065 0 6.75-5.475 12.225-12.225 12.225h-1.02a1.02 1.02 0 010-2.038h1.02c5.627 0 10.187-4.56 10.187-10.187 0-5.216-3.92-9.518-8.973-10.117a1.016 1.016 0 01-.782-.54 14.259 14.259 0 00-12.657-7.68zm.297 12.523a1.022 1.022 0 011.443 0l6.112 6.112c.397.4.397 1.043 0 1.443-.4.397-1.043.397-1.442 0l-4.373-4.375v13.84a1.02 1.02 0 01-2.037 0v-13.84l-4.373 4.375c-.4.397-1.043.397-1.442 0a1.022 1.022 0 010-1.443l6.112-6.112z"
                transform="translate(-1158.577 -586.896)"
                fill="url(#linearGradient)"
                stroke="none"
                strokeWidth={1}
                fillRule="evenodd"
            />
        </svg>
    )
}

export function FileNotConnected({color}: TProps) {
    return (
        <svg viewBox="0 0 26.0869565 40"
             xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M30.249 24.162c0-.48.39-.87.87-.87h24.347a.87.87 0 010 1.74h-.87v6.307a7.833 7.833 0 01-2.815 6.013l-7.13 5.94 7.13 5.943a7.827 7.827 0 012.816 6.01v6.308h.87a.87.87 0 010 1.74H31.118a.87.87 0 010-1.74h.87v-6.308a7.827 7.827 0 012.815-6.012l7.13-5.94-7.13-5.941a7.827 7.827 0 01-2.816-6.013v-6.307h-.87a.87.87 0 01-.87-.87zm3.478.87v6.307c0 1.806.802 3.519 2.192 4.675l7.373 6.148 7.374-6.148a6.081 6.081 0 002.192-4.675v-6.307h-19.13zm9.565 19.39l-7.373 6.149a6.081 6.081 0 00-2.192 4.674v6.308h19.13v-6.308a6.081 6.081 0 00-2.19-4.674l-7.375-6.148z"
                transform="translate(-1137.465 -585.5) translate(1107.216 562.208)"
                fill={color ? color : "#FFF"}
                stroke="none"
                strokeWidth={1}
                fillRule="evenodd"
            />
        </svg>
    )
}



